import {
  Component,
  computed,
  DestroyRef,
  effect,
  inject,
  Injector,
  OnInit,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import {SelectModule} from 'primeng/select';
import {TextareaModule} from 'primeng/textarea';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule} from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import {ProgressBar} from 'primeng/progressbar';
import {AllCourses} from '../../core/interface/courses/allCourses.interface';
import {CoursesService} from '../../core/service/courses/allCourses.service';
import {takeUntilDestroyed, toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {firstValueFrom, from, Observable} from 'rxjs';
import {NotificationService} from '../../../assets/shared/notification/notification.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'home',
  imports: [
    FormsModule,
    RadioButtonModule,
    SelectModule,
    InputTextModule,
    RadioButtonModule,
    TextareaModule,
    ProgressBar,
  ],
  providers:[CoursesService],
  templateUrl: './home.html',
  standalone: true,
  styleUrl: './home.scss',
})
export class Home implements OnInit {
  private notification = inject(NotificationService);
  private activeRoute = inject(ActivatedRoute);
  private injector = inject(Injector);
  private destroy = inject(DestroyRef)
  private coursesService = inject(CoursesService)
  private router = inject(Router);
  private route = inject(ActivatedRoute)
  public openedIndexes: number[] = [];
  public isOpenQuestionnaire= signal<boolean>(false);
  public coursesId?: string;
  public firstAviable:WritableSignal<boolean>= signal<boolean>(false)
  public allCourses: Signal<AllCourses> = toSignal(
    from(
      (async (): Promise<AllCourses> => {
        try {
          return await firstValueFrom(
            this.coursesService.getAllCourses(Number(this.activeRoute.snapshot.parent?.paramMap.get('coursesId'))) as Observable<AllCourses>
          );
        } catch (err: any) {
          if (err.status === 404) {
            this.router.navigate(['/error-course']);
            return new Promise<AllCourses>(() => {});
          }
          throw err;
        }})()), { initialValue: undefined as unknown as AllCourses }
  );

  ngOnInit() {
    this.coursesId = this.activeRoute.snapshot.parent?.paramMap.get('coursesId')!;
    this.getInfoGlobalTest(Number(this.coursesId))
    effect(() => {
      this.getActualModule();
    }, { injector: this.injector });
  }

  public getActualModule(){
    const courses = this.allCourses();
    if (!courses) return;
    const firstAvailableIndex = courses.modules.findIndex(module => module.isAvailable);
    if (firstAvailableIndex !== -1) {
      this.openedIndexes.push(firstAvailableIndex);
      this.firstAviable.set(true)
    }
  }
  public getInfoGlobalTest(courseId:number){
    this.coursesService.getInfoGlobalTest(courseId).pipe(takeUntilDestroyed(this.destroy)).subscribe(bool =>{
       this.isOpenQuestionnaire.set(Boolean(bool))
    })
  }

  public get progressBarLessons(): number {
    const total = this.allCourses()?.totalLessons ?? 0;
    const completed = this.allCourses()?.completedLessons ?? 0;

    if (!total) return 0;

    return Math.round((completed / total) * 100);
  }


  public goToLesson(type?: 'bth',id?: number) {
    if (type === 'bth') {
      const lessonId = this.allCourses()?.modules
        ?.find(m => m.isAvailable)?.lessons
        ?.find(l => l.isAvailable)
        ?.id;
      if (lessonId) {
        this.router.navigate([`/${this.coursesId}/lesson`, lessonId]);
      }
    } else {
      this.router.navigate([`/${this.coursesId}/lesson`, id]);
    }

  }

  public globalTest(){
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    this.router.navigate([this.coursesId ,'testing', 'final', '1'])
  }

  public sendSertificate(): void {
    const courseId = Number(this.route.snapshot.paramMap.get('coursesId'));

    this.coursesService
      .sertificate(courseId)
      .pipe(takeUntilDestroyed(this.destroy))
      .subscribe({
        next: (response) => {
          const userAgent = navigator.userAgent.toLowerCase();
          const isIOS = /iphone|ipad|ipod/.test(userAgent);
          const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
          const isGSA = userAgent.includes('gsa');

          let fileName = 'certificate.pdf';
          const contentDisposition = response.headers.get('content-disposition');

          if (contentDisposition) {
            const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
            const asciiMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (utf8Match) {
              fileName = decodeURIComponent(utf8Match[1]);
            } else if (asciiMatch) {
              fileName = asciiMatch[1];
            }
          }

          const blobType = (isIOS && isSafari) ? 'application/octet-stream' : 'application/pdf';
          const blob = new Blob([response.body!], { type: blobType });
          const fileURL = URL.createObjectURL(blob);

          if (isGSA) {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64data = reader.result as string;
              // В GSA открываем в том же окне. Это заставит приложение показать
              // системное меню "Открыть в..." или предпросмотр PDF
              window.location.href = base64data;
            };
            reader.readAsDataURL(blob);

          } else if (isIOS) {
            if (isSafari) {
              const a = document.createElement('a');
              a.href = fileURL;
              a.download = fileName;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            } else {
              window.location.href = fileURL;
            }
          } else {
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }

          setTimeout(() => URL.revokeObjectURL(fileURL), (isIOS || isGSA) ? 15000 : 3000);
        },
        error: () => {
          this.notification.show("error", `Ошибка загрузки сертификата`, '');
        }
      });
  }



  public toggleModule(i: number) {
    const index = this.openedIndexes.indexOf(i);
    if (index > -1) {
      this.openedIndexes.splice(index, 1);
    } else {
      this.openedIndexes.push(i);
    }
  }
  public startCourses(){

    const lessonId = this.allCourses()?.modules[0]?.lessons[0]?.id;
    if (lessonId) {
      this.router.navigate([`/${this.coursesId}/lesson`, lessonId]);
    }
  }
  public goToQuestionnaire(){
    this.router.navigate([this.coursesId, 'anketa']);
  }
  public goToTesting(moduleId:number){
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    this.router.navigate([this.coursesId ,'testing','intermediate', moduleId])
  }

}
